import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Attachment"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M20.3255 13.425L10.5755 3.67499C8.65081 1.89006 5.65925 1.94641 3.8031 3.80255C1.94696 5.6587 1.89061 8.65026 3.67554 10.575L5.92554 12.825L6.98304 11.7675L4.73304 9.51749C3.8301 8.67612 3.45842 7.40899 3.7638 6.21319C4.06919 5.01739 5.00294 4.08364 6.19874 3.77826C7.39454 3.47287 8.66167 3.84455 9.50304 4.74749L19.253 14.4975C20.156 15.3389 20.5277 16.606 20.2223 17.8018C19.9169 18.9976 18.9831 19.9313 17.7873 20.2367C16.5915 20.5421 15.3244 20.1704 14.483 19.2675L9.88554 14.67C9.40859 14.1957 9.22089 13.503 9.39315 12.8528C9.5654 12.2027 10.0714 11.6938 10.7206 11.5178C11.3699 11.3419 12.0636 11.5257 12.5405 12L14.918 14.3775L15.9755 13.32C15.9755 13.32 13.5605 10.8975 13.538 10.89C12.2092 9.66281 10.1483 9.70458 8.87029 10.9846C7.59228 12.2646 7.55376 14.3256 8.78304 15.6525L13.4255 20.325C15.3503 22.1099 18.3418 22.0536 20.198 20.1974C22.0541 18.3413 22.1105 15.3497 20.3255 13.425Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Attachment.vue"]]);
